import { render, staticRenderFns } from "./BascCard.vue?vue&type=template&id=0660140b&scoped=true&"
var script = {}
import style0 from "./BascCard.vue?vue&type=style&index=0&id=0660140b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0660140b",
  null
  
)

export default component.exports